<template>
	<div class="SingleLunchGraph">
		<div
			ref="singleLunch"
			style="width: 100%; height: 300px; overflow: hidden;"
		></div>
		<!-- <div v-else>
			<h3 style="text-align: center; padding-top: 50px;">No Data Found</h3>
		</div> -->
	</div>
</template>
<script>
var echarts = require("echarts");
import { GraphData } from "../../../../mixins/baseReportGraphData";
import { EventBus } from "../../../eventBus";
import moment from "moment";

export default {
	name: "SingleLunchGraph",
	mixins: [GraphData],
	props: {
		graphDetails: {
			type: Array,
			default: () => []
		},
		graphSingleData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			daySchdulerGraphInstance: "",
			// colors: ["#ffb133", "#409eff", "#f9acaa"],
			colors: ["#e29d5a", "#f9cb9c", "#fce5cd"],
			isGraphDataAvailable: true
		};
	},
	mounted() {
		this.initBaseGraph();
		// this.map_graph_data(this.graphDetails, this.graphSingleData);
		EventBus.$on("reponseLunchOfGraph", data => {
			this.clearGraph();
			// this.initBaseGraph();
			this.map_graph_data(data);
		});
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		map_graph_data(graph_data) {
			this.graphXaxis[0].data = [];
			this.graphSeries = [];
			this.getNameOfGraph = "";
			this.graphColors = this.colors;
			this.graphLegend.top = 10;
			this.grid = {
				left: "15%",
				right: "15%"
			};
			let Sales = {
				name: "Sales",
				type: "bar",
				stack: "Sales",
				barGap: 1,
				data: []
			};

			let Target = {
				name: "Target ",
				type: "bar",
				// stack: "Sales",
				barGap: 1,
				data: []
			};

			let Acheivement = {
				name: "Acheivement",
				type: "line",
				// stack: 'Sales',
				label: {
					show: true,
					formatter: "{c}  %",
					position: "inside"
				},
				// barGap: 1,
				// markPoint: {
				// 	data: [
				// 		{ type: "max", name: "Acheivement" }
				// 		{ type: "min", name: "Acheivement" }
				// 	]
				// },
				// markLine: {
				// 	data: [{ type: "average", name: "Acheivement" }]
				// },
				data: [],
				yAxisIndex: 1
			};
			let Forecast = {
				name: "Forecast",
				type: "bar",
				barGap: 1,
				data: []
				// yAxisIndex: 1
			};
			let data1 = {
				name: "Last Period",
				type: "bar",
				barGap: 1,
				data: []
				// yAxisIndex: 1
			};
			// this.grid = {
			// 	left: "10%"
			// };
			if (graph_data.length) {
				// this.graphXaxis[0].axisLabel.rotate = 90;
				// this.graphYaxis[0].axisLine = {
				// 	show: false
				// };
				this.graphYaxis = [
					{
						type: "value",
						name: "",
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							margin: 5,
							fontSize: "10"
							// formatter: function(a) {
							// 	console.log("a", a);
							// 	return a / 1000000 + 'M';
							// }
						}
					},
					{
						type: "value",
						name: "",
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							formatter: "{value}%",
							margin: 20
						}
					}
				];
				this.graphXaxis[0].axisLine = {
					show: false
				};
				this.graphXaxis[0].axisTick = {
					show: false
				};
				this.graphXaxis[0].axisLabel = {
					// interval: 0,
					// rotate: 50,
					margin: 20,
					formatter: function(d) {
						return d;
					}
				};
				if (graph_data.length > 1) {
					this.graphXaxis[0].axisLabel = {
						margin: 5,
						fontSize: "10",
						rotate: 25,
						formatter: function(d) {
							return d;
						}
					};
				}
				for (var i = 0; i < graph_data.length; i++) {
					if (graph_data[i].name) {
						this.graphXaxis[0].data.push(graph_data[i].name);
					}
					// 	this.graphXaxis[0].data.push(
					// 		new Date(graph_data[i].datetime).toLocaleString("en-US", {
					// 			hour: "numeric",
					// 			hour12: true
					// 		})
					// 	);
					if (graph_data[i].id) {
						Forecast.data.push(0);
						Sales.data.push(
							graph_data[i].current_total ? graph_data[i].current_total : 0
						);
						Target.data.push(graph_data[i].target ? graph_data[i].target : 0);
						data1.data.push(
							graph_data[i].previous_total ? graph_data[i].previous_total : 0
						);
						Acheivement.data.push(0);
					} else {
						Forecast.data.push(
							graph_data[i].forecast ? graph_data[i].forecast : 0
						);
						Sales.data.push(
							graph_data[i].total_sales ? graph_data[i].total_sales : 0
						);
						Target.data.push(graph_data[i].target ? graph_data[i].target : 0);
						data1.data.push(
							graph_data[i].previous_sales ? graph_data[i].previous_sales : 0
						);
						Acheivement.data.push(
							graph_data[i].target_hit_probability
								? graph_data[i].target_hit_probability
								: 0
						);
					}
				}
				if (graph_data.length > 1) {
					// Sales.barWidth = 15;
					// Target.barWidth = 15;
					// Forecast.barWidth = 15;
					// data1.barWidth = 15;
					// Acheivement.barWidth = 15;
				} else {
					Sales.barWidth = 40;
					Target.barWidth = 40;
					Forecast.barWidth = 40;
					data1.barWidth = 40;
					Acheivement.barWidth = 40;
				}
				this.graphSeries.push(Sales);
				this.graphSeries.push(Target);
				this.graphSeries.push(Forecast);
				this.graphSeries.push(data1);
				// this.graphSeries.push(Acheivement);
			} else {
				this.isGraphDataAvailable = false;
			}

			this.reRenderGraph();
			// console.log("graphData", this.graphData);
		},

		clearGraph: function() {
			this.daySchdulerGraphInstance.clear();
		},

		reRenderGraph: function() {
			this.clearGraph();
			this.daySchdulerGraphInstance.setOption(this.graphData);
			this.daySchdulerGraphInstance.hideLoading();
		},

		initBaseGraph() {
			let baseGraphContainer = this.$refs["singleLunch"];
			this.daySchdulerGraphInstance = echarts.init(
				baseGraphContainer,
				null,
				this.initOptions
			);
			this.daySchdulerGraphInstance.showLoading();
		}
	}
};
</script>
<style lang="scss" scoped>
.SingleLunchGraph {
	margin: 0 10px;
}</style
>>
